<template>
  <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.57084 5.14251C9.21818 5.53091 9.21818 6.46909 8.57085 6.85749L1.5145 11.0913C0.847972 11.4912 0 11.0111 0 10.2338V1.76619C0 0.988896 0.847971 0.508783 1.5145 0.908698L8.57084 5.14251Z" fill="#D64633"/>
  </svg>
</template>